import { useMemo } from 'react';

import { useFormat } from '@nucleus-commerce/i18n/react';

import { getTemporalLocale, type DateOrder, type TemporalLocale } from './locale';

/**
 * The pickers' locale: `override` when given, otherwise the app's formatting locale (the
 * `FormatProvider` override or the i18next language), as `useFormat` resolves it.
 */
export function useTemporalLocale(override?: string, dateOrder?: DateOrder): TemporalLocale {
  const { locale } = useFormat();
  const tag = override ?? locale;
  return useMemo(() => getTemporalLocale(tag, dateOrder), [tag, dateOrder]);
}
